/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';

export const buildHeadersFromRequest = ({ request, config = {} }) => {
  const {
    apiAuth,
    country,
    currentUrl,
    ip,
    locale,
    referer,
    rooGuid,
    rooSessionGuid,
    rooStickyGuid,
    userAgent,
  } = request;

  const isServer = typeof window === 'undefined';
  const proxiedHeaders = isServer
    ? {
        Referer: currentUrl,
        'X-Forwarded-For': ip,
      }
    : {};

  const authorizationHeader = (requestApiAuth) => {
    if (!requestApiAuth) {
      return '';
    }
    if (requestApiAuth.indexOf('.') !== -1) {
      // Only JWT based API Auth will have a period in it
      return `Bearer ${requestApiAuth}`;
    }
    // Opaque-token based authentication with Orderweb
    return `Basic ${requestApiAuth}`;
  };

  const uaEnv = isServer ? 'server' : 'browser';

  /*
    Use the sticky guid from
      - The cookie in the request if present.
      - From config if a cookie isn't set.
    If neither option has a stickyguid fallback to the users normal guid.
  */
  const stickyGuid = rooStickyGuid || config.rooStickyGuid || rooGuid;

  return Object.assign(
    {},
    {
      'Accept-Language': locale,
      Authorization: authorizationHeader(apiAuth),
      'User-Agent': `${userAgent} (deliveroo/consumer-web-app; ${uaEnv})`,
      'X-Roo-Client': 'consumer-web-app',
      'X-Roo-Client-Referer': referer || '',
      'X-Roo-Country': country.tld,
      'X-Roo-Guid': rooGuid,
      'X-Roo-Session-Guid': rooSessionGuid,
      'X-Roo-Sticky-Guid': stickyGuid,
    },
    proxiedHeaders,
  );
};

export const replaceUrlQueries = (currentUrl, addQueries, removeQueries = []) => {
  const urlWithoutTrailingSlash = currentUrl.replace('/?', '?');
  const urlParts = urlWithoutTrailingSlash.split('?');
  const urlWithoutQueries = urlParts[0];
  const urlQueryString = urlParts[1] || '';

  const queries = queryString.parse(urlQueryString);
  removeQueries.forEach((queryKey) => {
    delete queries[queryKey];
  });

  const newQueries = { ...queries, ...addQueries };
  const newUrl = `${urlWithoutQueries}?${queryString.stringify(newQueries)}`;

  return {
    queries: newQueries,
    url: newUrl,
  };
};
